import { Component, effect } from '@angular/core';
import { DataService } from '../../../shared/services/data.service';
import { FileViewerComponent } from "../file-viewer/file-viewer.component";
import { PRIMENG_MODULES } from '../../primeng-imports';

@Component({
    selector: 'app-print-view',
    templateUrl: './print-view.component.html',
    standalone:true,
    imports: [...PRIMENG_MODULES, FileViewerComponent]
})
export class PrintViewComponent {
    selectedFileName: any;
    selectedFileUrl: any;
    itemId: any;

    constructor(
        private dataService: DataService,
    ) {
        effect(() => {
            const result: any = this.dataService.printDataSignal();
            this.selectedFileName = result?.selectedFileName || '';
            this.selectedFileUrl = result?.selectedFileUrl || '';
            this.itemId = result?.itemId || '';
        });
    }
    ngOnInit() {
    }
}